import Main from '../../views/main'
import {ParentView} from '@/ladmin'

export default [
  {
    path: '/vehicleRegister',
    name: 'vehicleRegister',
    component: Main,
    meta: {
      disabled: true,
      label: '车辆登记'
    },
    children: [
      {
        name: 'vehicleReviewList',
        path: 'vehicleReviewList',
        component: () => import( '@/views/Register/vehicleReviewList'),
        meta: {
          label: '车辆审核',
        },
      },
      {
        name: 'vehicleReviewListParent',
        path: 'vehicleReviewListParent',
        component: ParentView,
        meta: {
          label: '车辆审核'
        },
        redirect: {name: 'vehicleReviewList'},
        children: [
          {
            name: 'vehicleDetailContentBox',
            path: 'vehicleDetailContentBox',
            prop: true,
            component: () => import('@/views/Register/vehicleDetailContentBox'),
            meta: {
              label: '车辆详细信息',
            },
          }
        ]
      },
      {
        name: 'selfVehicleList',
        path: 'selfVehicleList',
        component: () => import('@/views/Register/selfVehicleList'),
        meta: {
          label: '我的车辆'
        }
      },
      {
        name: 'registerConfig',
        path: 'registerConfig',
        component: () => import(/* webpackChunkName: "reservation" */ '@/views/Register/registerConfig'),
        meta: {
          label: '登记规则',
        },
        children: [
        ]
      },
      {
        name: 'registerConfigParent',
        component: ParentView,
        redirect: {name: 'registerConfig'},
        path: 'registerConfig',
        meta: {
          label: '登记规则',
        },
        children: [
          {
            name: 'commonConfig',
            path: 'commonConfig',
            prop: true,
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Register/commonConfigBox'),
            meta: {
              label: '配置详情',
            },
          },
          {
            name: 'newCommonConfig',
            path: 'newCommonConfig',
            prop: true,
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Register/commonConfigBox'),
            meta: {
              label: '新增配置',
            },
          }
        ]
      },
      {
        name: 'extraConfigList',
        component: () => import('@/views/Register/extraConfigList'),
        path: 'extraConfigList',
        meta: {
          label: '分组详情配置列表',
        },
      },
      {
        name: 'extraConfigParent',
        component: ParentView,
        redirect: {name: 'extraConfigList'},
        path: 'extraConfigParent',
        meta: {
          label: '分组详情配置列表',
        },
        children: [
          {
            name: 'extraConfig',
            path: 'extraConfig',
            prop: true,
            component: () => import(/* webpackChunkName: "reservation" */ '@/views/Register/extraConfig'),
            meta: {
              label: '分组详情配置',
              keepAlive: true
            },
          }
        ]
      },
      {
        name: 'vehicleBind',
        component: () => import('@/views/Register/vehicleBind'),
        path: 'vehicleBind',
        meta: {
          label: '车辆绑定'
        },
      },
    ]
  }
]
